var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningRoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFED9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2083 25.7961C23.0243 20.8133 24.4323 18.3219 26.3643 17.6806C27.4272 17.3278 28.5721 17.3278 29.635 17.6806C31.5671 18.3219 32.9751 20.8133 35.791 25.7961C38.607 30.7789 40.0149 33.2702 39.5926 35.3003C39.3602 36.417 38.7877 37.43 37.9572 38.194C36.4475 39.5827 33.6316 39.5827 27.9997 39.5827C22.3678 39.5827 19.5518 39.5827 18.0421 38.194C17.2116 37.43 16.6391 36.417 16.4068 35.3003C15.9844 33.2702 17.3924 30.7789 20.2083 25.7961Z",
    stroke: "#DB6E00",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.99 33.166H28.0005",
    stroke: "#DB6E00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29.666L28 24.9993",
    stroke: "#DB6E00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRoundIcon);
export default __webpack_public_path__ + "static/media/warning-round-icon.eb165ab44b93e37d67a630d1b0d396bc.svg";
export { ForwardRef as ReactComponent };